import React, { PropsWithChildren } from 'react';
import { Heading } from '../Heading/Heading';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import Bem from '../../../lib/bemUtils/bem';

type BlockBarProps = PropsWithChildren<{
  heading: string;
  position?: string;
  hierarchy: number;
  modifier?: Modifier<'border-top' | 'border-bottom' | 'no-horizontal-padding' | 'no-padding'>;
}>;

export function BlockBar({ heading, position, hierarchy, children, modifier }: BlockBarProps) {
  return (
    <div className={Bem('block-bar', modifier)}>
      <Heading className="block-bar__heading" hierarchy={hierarchy}>
        {heading}
        {position && <span className="block-bar__heading-position">{position}</span>}
      </Heading>
      {children}
    </div>
  );
}
